import { createActions, createReducer } from 'reduxsauce'

import ConsultaAtaRegistroPrecoMPService from '../../servicos/ConsultaAtaRegistroPrecoMPService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaAtaRegistroPrecoMPInicio: [],
    buscaConsultaAtaRegistroPrecoMPErro: ['erro'],
    buscaConsultaAtaRegistroPrecoMPSucesso: ['consultaAtaRegistroPrecoMP'],
    limpar: [],
    setConsultaAtaRegistroPrecoMPEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaAtaRegistroPrecoMP = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaAtaRegistroPrecoMPInicio())
        let serv = new ConsultaAtaRegistroPrecoMPService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaAtaRegistroPrecoMPSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaAtaRegistroPrecoMPErro(error)))
    }
}

const buscaConsultaAtaRegistroPrecoMPInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaAtaRegistroPrecoMPErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaAtaRegistroPrecoMPSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaAtaRegistroPrecoMP.resultado,
        dataSincronizacaoDados: action.consultaAtaRegistroPrecoMP.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaAtaRegistroPrecoMPEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_ATA_REGISTRO_PRECO_MP_INICIO]: buscaConsultaAtaRegistroPrecoMPInicio,
    [Types.BUSCA_CONSULTA_ATA_REGISTRO_PRECO_MP_ERRO]: buscaConsultaAtaRegistroPrecoMPErro,
    [Types.BUSCA_CONSULTA_ATA_REGISTRO_PRECO_MP_SUCESSO]: buscaConsultaAtaRegistroPrecoMPSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_ATA_REGISTRO_PRECO_MP_ESTADO_DT]: setConsultaAtaRegistroPrecoMPEstadoDT,
})
